import * as ng from 'angular';
import * as _ from 'underscore';

import PerfectScrollbar from 'perfect-scrollbar';

ng.module('e360')
   .directive('nvScrollable', scrollableDirective);

/**
 * Directive wrapper around perfect-scrollbar.
 */
scrollableDirective.$inject = ['$window']
export function scrollableDirective($window:ng.IWindowService): ng.IDirective {
   return {
      restrict: 'A',
      link: scrollableDirectiveLinkFn
   };

   function scrollableDirectiveLinkFn(scope:ng.IScope, element:ng.IAugmentedJQuery, attrs:ng.IAttributes) {
      let domElement = element[0];

      scope.$on('$destroy', destroy);

      // update scrollbars when content height of this element changes
      scope.$watch(() => domElement.scrollHeight, update);

      // update scrollbars this elements visible area changes (offset height)
      // which most likely happens whenever the browser is resized
      // debounced to avoid spamming update when dragging to resize
      ng.element($window)
         .on('resize', _.debounce(update, 300));

      let ps = new PerfectScrollbar(domElement);

      function update() {
         ps.update();
      }

      function destroy() {
         ps.destroy();
      }
   }
}
